// Suppliers Storytelling Animation with GSAP
gsap.registerPlugin(ScrollTrigger);

// Initialize suppliers storytelling animations
function initSuppliersStorytelling() {
    // Only run if the elements exist on the page to prevent GSAP warnings
    if (!document.querySelector('.pirelli-section') && !document.querySelector('.maggion-section')) {
        return;
    }
    // Pirelli Section - Content slides in from left
    gsap.timeline({
        scrollTrigger: {
            trigger: '.pirelli-section',
            start: 'top 60%',
            end: 'top 20%',
            scrub: 1,
            markers: false,
        }
    })
        .fromTo('.pirelli-section .section-tag',
            { opacity: 0, x: -30 },
            { opacity: 1, x: 0, duration: 0.6 }
        )
        .fromTo('.pirelli-section .section-title',
            { opacity: 0, x: -40, scale: 0.95 },
            { opacity: 1, x: 0, scale: 1, duration: 0.8 },
            '-=0.4'
        )
        .fromTo('.pirelli-section .supplier-text',
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.7 },
            '-=0.5'
        )
        .fromTo('.pirelli-section .supplier-logo',
            { opacity: 0, scale: 0.9, y: 20 },
            { opacity: 1, scale: 1, y: 0, duration: 0.8 },
            '-=0.6'
        );

    // Maggion Section - Content slides in from right
    gsap.timeline({
        scrollTrigger: {
            trigger: '.maggion-section',
            start: 'top 60%',
            end: 'top 20%',
            scrub: 1,
            markers: false,
        }
    })
        .fromTo('.maggion-section .section-tag',
            { opacity: 0, x: 30 },
            { opacity: 1, x: 0, duration: 0.6 }
        )
        .fromTo('.maggion-section .section-title',
            { opacity: 0, x: 40, scale: 0.95 },
            { opacity: 1, x: 0, scale: 1, duration: 0.8 },
            '-=0.4'
        )
        .fromTo('.maggion-section .supplier-text',
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.7 },
            '-=0.5'
        )
        .fromTo('.maggion-section .supplier-logo',
            { opacity: 0, scale: 0.9, y: 20 },
            { opacity: 1, scale: 1, y: 0, duration: 0.8 },
            '-=0.6'
        );

    // Parallax effect on logos with scroll
    gsap.timeline({
        scrollTrigger: {
            trigger: '.supplier-section',
            start: 'top center',
            end: 'bottom center',
            scrub: 0.5,
        }
    })
        .to('.pirelli-section .supplier-logo',
            { y: -30, duration: 1 },
            0
        )
        .to('.maggion-section .supplier-logo',
            { y: -30, duration: 1 },
            0
        );

    // Subtle hover animation
    document.querySelectorAll('.supplier-section').forEach(section => {
        section.addEventListener('mouseenter', () => {
            gsap.to(section.querySelector('.supplier-logo'), {
                scale: 1.05,
                duration: 0.3,
                overwrite: 'auto'
            });
        });

        section.addEventListener('mouseleave', () => {
            gsap.to(section.querySelector('.supplier-logo'), {
                scale: 1,
                duration: 0.3,
                overwrite: 'auto'
            });
        });
    });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initSuppliersStorytelling);

// Refresh ScrollTrigger on window resize
window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
});
